<template>
    <div>
        <SubHeader :text="$t('h.mobility')" :imgUrl="imgUrl" />
        <Content0 />
        <Content1 />
    </div>
</template>
<script>
import SubHeader from "@/components/SubHeader.vue";
import Content0 from "./Content0.vue";
import Content1 from "./Content1.vue";
import initAnimation from "../animation";
export default {
    data() {
        return {
            imgUrl: require("@/assets/images/sub_page_banner_5.jpg"),
        };
    },
    mounted() {
        setTimeout(initAnimation, 0);
    },
    components: {
        SubHeader,
        Content0,
        Content1,
    },
};
</script>



// WEBPACK FOOTER //
// src/Pages/MobileClient/MobileClient.vue